export namespace XssOptions {

    export const options: {} = getOptions();

    function getOptions(): {} {
      const tags = [
        'strike', 'del', 'dd', 'h3', 'small', 'big', 'sub', 'tt', 'fieldset', 'a', 'ul', 'h4',
        'cite', 'dfn', 'thead', 'legend', 'h5', 'kbd', 'code', 'b', 'ins', 'img', 'acronym',
        'h6', 'sup', 'pre', 'iframe', 'tbody', 'blockquote', 'td', 'o:p', 'dt', 'br', 'output',
        'p', 'strong', 'caption', 'div', 'samp', 'table', 'li', 'ol', 'var', 's', 'font', 'tr',
        'em', 'th', 'h1', 'address', 'i', 'abbr', 'h2', 'span', 'hr', 'u'];

      const attributes = [
        'name', 'face', 'href', 'cellspacing', 'bgcolor', 'size', 'cite', 'dir', 'class',
        'title', 'src', 'border', 'summary', 'color', 'height', 'rowspan', 'cellpadding',
        'align', 'datetime', 'alt', 'colspan', 'style', 'target', 'width'];

      let whiteList = {};
      tags.forEach((tag) => {
          whiteList[tag] = attributes;
      });

      return { whiteList: whiteList };
    }
}
